<template>
        <!-- 账单明细列表 -->
        <el-table :key="0" :data="list" stripe v-loading="loading" :element-loading-text="loadingText" border
                    fit highlight-current-row class="w-100">

            <!-- 保单号 -->
            <el-table-column align="left" label="保单号" >
            <template slot-scope="scope">
                <!-- <span v-if="$perm(['company.view_insurance_company'])" class="text-link"
                    @click="handleUpdate(scope.row.id)">{{scope.row.policy_number}}</span> -->
                <span>{{scope.row.policy_number}}</span>
            </template>
            </el-table-column>

            <!-- 险种代码 -->
            <el-table-column align="left" label="险种代码" >
            <template slot-scope="scope">
                <span>{{ scope.row.insruance_type_code }}</span>
            </template>
            </el-table-column>

            <!-- 投保人 -->
            <el-table-column align="left" label="投保人" >
            <template slot-scope="scope">
                <span>{{ scope.row.policy_holder }}</span>
            </template>
            </el-table-column>

            <!-- 被保险人 -->
            <el-table-column align="left" label="被保险人" >
            <template slot-scope="scope">
                <span>{{ scope.row.insured}}</span>
            </template>
            </el-table-column>

            <!-- 起保日期 -->
            <el-table-column align="left" label="起保日期" >
            <template slot-scope="scope">
                <span>{{ scope.row.effective_date| parseTime('{y}年{m}月{d}日') }}</span>
            </template>
            </el-table-column>

            <!-- 终保日期 -->
            <el-table-column align="left" label="终保日期" >
            <template slot-scope="scope">
                <span>{{ scope.row.end_date| parseTime('{y}年{m}月{d}日') }}</span>
            </template>
            </el-table-column>

            <!-- 总保费 -->
            <el-table-column align="left" label="总保费" >
            <template slot-scope="scope">
                <span>{{ scope.row.premium | parsecurrency }}</span>
            </template>
            </el-table-column>

            <!-- 费用比例 -->
            <el-table-column align="left" label="费用比例" >
            <template slot-scope="scope">
                <span>{{ scope.row.commission_rate}}</span>
            </template>
            </el-table-column>

            <!-- 手续费-->
            <el-table-column align="left" label="手续费" >
            <template slot-scope="scope">
                <span>{{ scope.row.commission | parsecurrency }}</span>
            </template>
            </el-table-column>

            <!-- 核保完成日期 -->
            <el-table-column align="left" label="核保完成日期" >
            <template slot-scope="scope">
                <span>{{ scope.row.underwriting_completion_date | parseTime('{y}年{m}月{d}日') }}</span>
            </template>
            </el-table-column>

        </el-table>
</template>

<script>
import { formatCurrency } from '@/utils/misc'
export default {
    name: 'billing-record-list-ren-bao',
    components: {
    },
    filters: {
      parsecurrency: function(value){
        let v = parseFloat(value).toFixed(4)
        return formatCurrency(v, 2)
      },
    },
    props: [
        'list',
        'loading',
        'loadingText'
    ]
}
</script>
<style lang="scss">

</style>
